import React, { useEffect, useMemo, useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";
import useApi from "./useApi";
import Loader from "src/components/loader.component";
import { Alert } from "react-bootstrap";
import NoData from "src/components/shared/noDataComponent";

const stateKeys = {
    chart: "chart",
};
if (typeof Highcharts === "object") {
    Drilldown(Highcharts);
}
function BarChart({
    fetchOptions,
    fetchMethod,
    chartOptions,
    shouldFetch,
    chartProperties,
    events,
    isDonut,
    donutInnerSize,
    seriesData,
    otherOptions,
    hasFetchParams,
    fetchParams,
    seriesKey = "series",
    shouldClear
}) {
    const { awaitingResponse, data, error, handleApi } = useApi();
    const [options, setOptions] = useState(null)
    const { chart: chartState } = useMemo(() => {
        return stateKeys;
    }, []);
    const chartRef = useRef(null);
    useEffect(() => {
        shouldFetch && handleApi(fetchMethod, fetchOptions, stateKeys["chart"], hasFetchParams, fetchParams,shouldClear );
    }, [shouldFetch, hasFetchParams, fetchParams,shouldClear]);

    useEffect(() => {
        !shouldFetch && setOptions({...otherOptions,...options,chart:{...propertiesForChart},series:seriesData?.[seriesKey]})
      }, [shouldFetch, chartOptions,seriesData])
    const setInnerSize = (seriesToDrill) => {
        seriesToDrill.innerSize = isDonut ? donutInnerSize : 0;
    };
    const drilldownEvents = (e) => {
        const { point, target, seriesOptions } = e;
        if (!seriesOptions) {
            const dataToDrill = shouldFetch ? data[chartState] : seriesData;
            for (let key in dataToDrill) {
                if (
                    dataToDrill[key] &&
                    key.includes("drilldown") &&
                    dataToDrill[key].hasOwnProperty(point.drilldown)
                ) {
                    const seriesToDrill = dataToDrill[key][point.drilldown];
                    if (
                        seriesToDrill["name"] === point.series.name &&
                        [undefined, null, "pie", ""].includes(seriesToDrill.type)
                    ) {
                        setInnerSize(seriesToDrill);
                        target.addSeriesAsDrilldown(point, seriesToDrill);
                    }
                }
            }
            target.applyDrilldown();
        }
    };

    const propertiesForChart =useMemo(()=>{
        const chartPropsToSet=chartProperties
        ? {
          ...chartProperties,
          className: "bg-gray",
        }
        : {};
    
        Object.defineProperties(chartPropsToSet, {
          events: {
            value: {
              ...events,
              drilldown: drilldownEvents,
            },
            writable: false,
            configurable: false,
            enumerable: true,
          },
          type: {
            value: "column",
            writable: false,
            configurable: true,
          },
          renderTo: {
            value: undefined,
            writable: false,
            configurable: false,
          },
          custom: { value: {}, writable: false, configurable: false },
        });
        return chartPropsToSet
      },[chartProperties])
    const handleApiResponse = () => {
        const chartData = data[chartState];
        const chartError = error[chartState];
      
        if (chartError) {
            return;
        }
        setOptions({
            ...otherOptions,
            chart: { ...propertiesForChart },
            drilldown: {
                series: [],
            }, series:  chartData?.[seriesKey]
        })
    };
    useEffect(() => {
        shouldFetch && handleApiResponse();
    }, [data[chartState], error[chartState]],shouldFetch);
    return (
        <>
            {awaitingResponse[chartState] && <Loader />}
            {error[chartState] && <Alert variant="danger" className="mt-16">
                <p style={{ color: 'red', margin: 0 }}><span className="icon error-alert me-2"></span>{error[chartState]}</p>
            </Alert>}
            {shouldFetch && !awaitingResponse[chartState] && data[chartState]?.[seriesKey] && data[chartState]?.[seriesKey]?.length > 0 && options && <HighchartsReact
                highcharts={Highcharts}
                options={options}
                ref={chartRef}
            />}
            {!shouldFetch && seriesData?.[seriesKey] && seriesData[seriesKey]?.length > 0 && options && <HighchartsReact
                highcharts={Highcharts}
                options={{
                    ...options,
                    title: {
                      text: "",
                    },
                  }}
                ref={chartRef}
            />}
            {shouldFetch && !awaitingResponse[chartState] && !error[chartState] && (!data[chartState]?.[seriesKey] || data[chartState]?.[seriesKey]?.length === 0) && <div className="chart-nodata"><span><NoData /></span></div>}
            {!shouldFetch && (!seriesData?.[seriesKey] && seriesData[seriesKey]?.length == 0) && <div className="chart-nodata"><span><NoData /></span></div>}

        </>
    );
}


export default React.memo(BarChart);
